import { FC, useLayoutEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
// Mui
import { Box } from '@mui/material';
// Layouts
import PagesToolbar from 'app/components/PagesToolbar';
// Components
import DocumentName from 'app/components/DocumentName';
// 
import FilesList from './FilesList';
import FilesStapleFab from './FilesStapleFab';
import FilesScroll from './FilesScroll';
import { useSelector } from 'react-redux';
import { selectFilteredDocumentPages } from 'app/store/page/page.selectors';

const DocumentPagesPage:FC = () => {
  const { documentId } = useParams<{ documentId:string }>();

  const pages = useSelector((state:any) => selectFilteredDocumentPages(state, {
    documentId: Number(documentId)
  }));

  const listRef = useRef<any>();

  useLayoutEffect(() => {
    const containerElem = document.querySelector('.scrollListContainer');
    if ( !containerElem ) return;
    containerElem.scrollTop = 0;
    // eslint-disable-next-line
  }, [documentId]);

  return (
    <PagesToolbar pages={pages} toolType="files" listRef={listRef}>
      <Box sx={{ height: '100%', display: 'flex' }}>
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <PagesToolbar.Bar>
            <PagesToolbar.Actions>
              <DocumentName />
            </PagesToolbar.Actions>
          </PagesToolbar.Bar>
          <PagesToolbar.Filters />
          <PagesToolbar.FiltersResults />
          <Box sx={{ flexGrow: 1, display: 'flex', position: 'relative' }}>
            <FilesList listRef={listRef} />
            <Box sx={{
              position: 'absolute',
              right: 0, bottom: 0,
              m: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: 2
            }}>
              <FilesScroll listRef={listRef} />
              <FilesStapleFab />
            </Box>
          </Box>
        </Box>
        <PagesToolbar.FiltersSidebar />
      </Box>
    </PagesToolbar>
  )
}

export default DocumentPagesPage;
